"use strict";

var _regeneratorRuntime = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Editor = void 0;
/* tslint:disable:indent */

var CanvasTools_Filter_1 = require("./CanvasTools.Filter");

var Rect_1 = require("./Core/Rect");

var ISelectorSettings_1 = require("./Interface/ISelectorSettings");

var RegionsManager_1 = require("./Region/RegionsManager");

var AreaSelector_1 = require("./Selection/AreaSelector");

var ToolbarIcon_1 = require("./Toolbar/ToolbarIcon");

var Toolbar_1 = require("./Toolbar/Toolbar");
/**
 * Wraps internal CanvasTools components into one Editor experience.
 */


var Editor = /*#__PURE__*/function () {
  function Editor(container, areaSelector, regionsManager, filterPipeline) {
    var _this = this;

    _classCallCheck(this, Editor);

    /**
     * Auto-resize flag to automatically update editor internals when the container (window) size is changed.
     */
    this.autoResize = true;
    /**
     * Internal reference to the RegionsManager freezing state.
     */

    this.isRMFrozen = false; // Create SVG Element

    this.canvas = this.createCanvasElement();
    this.editorSVG = this.createSVGElement();
    this.lastX = this.canvas.width / 2;
    this.lastY = this.canvas.height / 2;
    this.editorSVG.addEventListener("mousedown", function (event) {
      _this.onMouseDown(event);
    }, false);
    this.editorSVG.addEventListener("mousemove", function (event) {
      _this.onMouseMove(event);
    }, false);
    this.editorSVG.addEventListener("mouseup", function (event) {
      _this.onMouseUp(event);
    }, false);
    this.editorContainerDiv = container;
    this.editorContainerDiv.classList.add("CanvasToolsContainer");
    this.editorDiv = this.createDivElement();
    this.editorDiv.classList.add("CanvasToolsEditor");
    this.editorDiv.append(this.canvas);
    this.editorDiv.append(this.editorSVG);
    this.editorContainerDiv.append(this.editorDiv); // automatically resize internals on window resize

    window.addEventListener("resize", function (e) {
      if (_this.autoResize) {
        _this.resize(_this.editorContainerDiv.offsetWidth, _this.editorContainerDiv.offsetHeight);
      }
    }); // Init regionsManager

    var rmCallbacks = {
      onChange: null,
      onManipulationBegin: function onManipulationBegin(region) {
        _this.areaSelector.hide();

        if (typeof _this.onManipulationBegin === "function") {
          _this.onManipulationBegin(region);
        }
      },
      onManipulationEnd: function onManipulationEnd(region) {
        _this.areaSelector.show();

        if (typeof _this.onManipulationEnd === "function") {
          _this.onManipulationEnd(region);
        }
      },
      onRegionSelected: function onRegionSelected(id, multiselection) {
        if (typeof _this.onRegionSelected === "function") {
          _this.onRegionSelected(id, multiselection);
        }
      },
      onRegionMove: function onRegionMove(id, regionData) {
        if (typeof _this.onRegionMove === "function") {
          _this.onRegionMove(id, regionData);
        }
      },
      onRegionMoveBegin: function onRegionMoveBegin(id, regionData) {
        if (typeof _this.onRegionMoveBegin === "function") {
          _this.onRegionMoveBegin(id, regionData);
        }
      },
      onRegionMoveEnd: function onRegionMoveEnd(id, regionData) {
        if (typeof _this.onRegionMoveEnd === "function") {
          _this.onRegionMoveEnd(id, regionData);
        }
      },
      onRegionDelete: function onRegionDelete(id, regionData) {
        if (typeof _this.onRegionDelete === "function") {
          _this.onRegionDelete(id, regionData);
        }
      }
    };

    if (regionsManager !== null && regionsManager !== undefined) {
      this.regionsManager = regionsManager;
      regionsManager.callbacks = rmCallbacks;
    } else {
      this.regionsManager = new RegionsManager_1.RegionsManager(this.editorSVG, rmCallbacks);
    } // Init areaSeletor


    var asCallbacks = {
      onSelectionBegin: function onSelectionBegin() {
        _this.isRMFrozen = _this.regionsManager.isFrozen;

        _this.regionsManager.freeze();

        if (typeof _this.onSelectionBegin === "function") {
          _this.onSelectionBegin();
        }
      },
      onSelectionEnd: function onSelectionEnd(regionData) {
        if (!_this.isRMFrozen) {
          _this.regionsManager.unfreeze();
        }

        if (typeof _this.onSelectionEnd === "function") {
          _this.onSelectionEnd(regionData);
        }
      }
    };

    if (areaSelector !== null && areaSelector !== undefined) {
      this.areaSelector = areaSelector;
      this.areaSelector.callbacks = asCallbacks;
    } else {
      this.areaSelector = new AreaSelector_1.AreaSelector(this.editorSVG, asCallbacks);
    } // Init filterPipeline


    if (filterPipeline !== undefined && filterPipeline !== null) {
      this.filterPipeline = filterPipeline;
    } else {
      this.filterPipeline = new CanvasTools_Filter_1.FilterPipeline();
    } // Adjust editor size


    this.resize(container.offsetWidth, container.offsetHeight); // Add proxy to regionsManager, areaSelector and filterPipeline;

    this.mergedAPI = new Proxy(this, {
      get: function get(target, prop) {
        var p;
        var t;

        if (prop in target) {
          t = target;
          p = t[prop];
        } else if (prop in target.regionsManager) {
          t = target.RM;
          p = t[prop];
        } else if (prop in target.areaSelector) {
          t = target.AS;
          p = t[prop];
        } else if (prop in target.filterPipeline) {
          t = target.FP;
          p = t[prop];
        } else {
          p = undefined;
        }

        if (typeof p === "function") {
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            p.apply(t, args);
          };
        } else {
          return p;
        }
      }
    });
  }
  /**
   * A proxi wrapper around internal API for the `Editor` itself, `RegionsManager` (`RM`), `AreaSelector` (`AS`) and
   * `FilterPipeline` (`FP`).
   * @remarks As of now those apis do not overlap, so all methods/properties might be mapped from unified API.
   */


  _createClass(Editor, [{
    key: "addToolbar",

    /**
     * Creates a new toolbar in specified div-container
     * @param container - The div-container for the toolbar.
     * @param toolbarSet - Icons set for the toolbar.
     * @param iconsPath - Path to the toolbar icons.
     */
    value: function addToolbar(container, toolbarSet, iconsPath) {
      var _this2 = this;

      var svg = this.createSVGElement();
      container.append(svg);
      this.toolbar = new Toolbar_1.Toolbar(svg);

      if (toolbarSet === null || toolbarSet === undefined) {
        toolbarSet = Editor.FullToolbarSet;
      }

      var activeSelector;
      toolbarSet.forEach(function (item) {
        if (item.type === ToolbarIcon_1.ToolbarItemType.SEPARATOR) {
          _this2.toolbar.addSeparator();
        } else {
          var toolbarItem = {
            action: item.action,
            iconUrl: iconsPath + item.iconFile,
            tooltip: item.tooltip,
            keycode: item.keycode,
            width: item.width,
            height: item.height
          };

          var actionFn = function actionFn(action) {
            item.actionCallback(action, _this2.regionsManager, _this2.areaSelector);
          };

          if (item.type === ToolbarIcon_1.ToolbarItemType.SELECTOR) {
            _this2.toolbar.addSelector(toolbarItem, actionFn);

            if (item.activate) {
              activeSelector = item.action;
            }
          } else if (item.type === ToolbarIcon_1.ToolbarItemType.SWITCH) {
            _this2.toolbar.addSwitch(toolbarItem, actionFn);

            _this2.toolbar.setSwitch(item.action, item.activate);
          } else if (item.type === ToolbarIcon_1.ToolbarItemType.TRIGGER) {
            _this2.toolbar.addTrigger(toolbarItem, actionFn);
          }
        }
      });
      this.toolbar.select(activeSelector);
    }
    /**
     * Updates the content source for the editor.
     * @param source - Content source.
     * @returns A new `Promise` resolved when content is drawn and Editor is resized.
     */

  }, {
    key: "addContentSource",
    value: function () {
      var _addContentSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.source = source;
                this.sourceWidth = this.source.width;
                this.sourceHeight = this.source.height;
                this.canvas.width = this.source.width;
                this.canvas.height = this.source.height;
                this.canvasContext = this.canvas.getContext("2d");
                this.enchanceCanvasContext(this.canvasContext);
                return _context.abrupt("return", this.draw());

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addContentSource(_x) {
        return _addContentSource.apply(this, arguments);
      }

      return addContentSource;
    }()
  }, {
    key: "draw",
    value: function draw() {
      var _this3 = this;

      return this.filterPipeline.applyToCanvas(this.canvasContext).then(function (bcnvs) {
        var p1 = _this3.canvasContext.transformedPoint(0, 0);

        var p2 = _this3.canvasContext.transformedPoint(_this3.canvas.width, _this3.canvas.height);

        _this3.canvasContext.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);

        _this3.canvasContext.drawImage(_this3.source, 0, 0, _this3.canvas.width, _this3.canvas.height);
      }).then(function () {
        // resize the editor size to adjust to the new content size
        // this.resize(this.canvas.width, this.canvas.height);
        _this3.resize(_this3.editorContainerDiv.offsetWidth, _this3.editorContainerDiv.offsetHeight);
      });
    }
    /**
     * Resize editor to new width and height.
     * @remarks - Use if the `autoResize` is `false`.
     * @param containerWidth - The new container width.
     * @param containerHeight - The new container height.
     */

  }, {
    key: "resize",
    value: function resize(containerWidth, containerHeight) {
      this.frameWidth = containerWidth;
      this.frameHeight = containerHeight;
      var imgRatio = this.source ? this.source.naturalWidth / this.source.naturalHeight : this.canvas.offsetWidth / this.canvas.offsetHeight;
      var containerRatio = containerWidth / containerHeight;
      var hpadding = 0;
      var vpadding = 0;

      if (imgRatio > containerRatio) {
        vpadding = (containerHeight - containerWidth / imgRatio) / 2;
        this.editorDiv.style.height = "calc(100% - ".concat(vpadding * 2, "px)");
        this.editorDiv.style.width = "";
      } else {
        hpadding = (containerWidth - containerHeight * imgRatio) / 2;
        this.editorDiv.style.height = "";
        this.editorDiv.style.width = "calc(100% - ".concat(hpadding * 2, "px)");
      }

      this.editorDiv.style.padding = "".concat(vpadding, "px ").concat(hpadding, "px");
      this.frameWidth = containerWidth - hpadding * 2;
      this.frameHeight = containerHeight - vpadding * 2;
      this.areaSelector.resize(this.frameWidth, this.frameHeight);
      this.regionsManager.resize(this.frameWidth, this.frameHeight);
    }
  }, {
    key: "zoom",
    value: function zoom(scale) {
      var ctx = this.canvasContext;
      var factor = scale / ctx.currentScale();
      ctx.scale(factor, factor);
      console.debug("Total zoom ".concat(scale, ", DX=").concat(ctx.dx(), ", DY=").concat(ctx.dy())); // Beim Verkleinern von Bild die Position zurücksetzen sobald Bilddimensionen kleiner sind als unsere Ansicht

      var dx = 0;
      var dy = 0;
      var maxDX = -this.canvas.width * (scale - 1);

      if (ctx.dx() < maxDX) {
        dx = Math.abs(ctx.dx() - maxDX);
      }

      var maxDY = -this.canvas.height * (scale - 1);

      if (ctx.dy() < maxDY) {
        dy = Math.abs(ctx.dy() - maxDY);
      }

      ctx.translate(dx, dy);
      this.regionsManager.transform(ctx.currentScale(), ctx.dx(), ctx.dy());
      return this.draw();
    }
    /**
     * Short reference to the `RegionsManager` component.
     */

  }, {
    key: "scaleRegionToSourceSize",

    /**
     * Scales the `RegionData` object from frame to source size.
     * @param regionData - The `RegionData` object.
     * @param sourceWidth - [Optional] The source width.
     * @param sourceHeight - [Optional] The source height.
     * @returns Resized `RegionData` object.
     */
    value: function scaleRegionToSourceSize(regionData, sourceWidth, sourceHeight) {
      var isNewRegion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var sw = sourceWidth !== undefined ? sourceWidth : this.sourceWidth;
      var sh = sourceHeight !== undefined ? sourceHeight : this.sourceHeight; // Wenn wir neuen Region hinzufügen und unser Bild vergrößert ist, müssen wir die reale Größe
      // um Zoom-Factor verkleinern da der Benutzer im Moment alles vergrößert sieht
      // Aber bei bereits vorhandenen Regionen stimmt die Größe bereits sowie position

      var magnifyFactor = isNewRegion ? this.canvasContext.currentScale() : 1;
      var xf = sw / (magnifyFactor * this.frameWidth);
      var yf = sh / (magnifyFactor * this.frameHeight);
      var rd = regionData.copy(); // Soll bevor scale passieren und nur wenn ein neuer Region hinzugefügt wird

      if (isNewRegion) {
        rd.move(rd.x - this.canvasContext.dx(), rd.y - this.canvasContext.dy());
      }

      rd.scale(xf, yf);
      return rd;
    }
    /**
     * Scales the `RegionData` object from source to frame size.
     * @param regionData - The `RegionData` object.
     * @param sourceWidth - [Optional] The source width.
     * @param sourceHeight - [Optional] The source height.
     * @returns Resized `RegionData` object.
     */

  }, {
    key: "scaleRegionToFrameSize",
    value: function scaleRegionToFrameSize(regionData, sourceWidth, sourceHeight) {
      var sw = sourceWidth !== undefined ? sourceWidth : this.sourceWidth;
      var sh = sourceHeight !== undefined ? sourceHeight : this.sourceHeight;
      var xf = this.frameWidth / sw;
      var yf = this.frameHeight / sh;
      var rd = regionData.copy();
      rd.scale(xf, yf);
      return rd;
    }
    /**
     * Internal helper to create a new SVG element.
     */

  }, {
    key: "createSVGElement",
    value: function createSVGElement() {
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.innerHTML = Editor.SVGDefsTemplate;

      svg.ondragstart = function () {
        return false;
      };

      svg.ondragend = function () {
        return false;
      };

      return svg;
    }
    /**
     * Internal helper to create a new HTMLCanvas element.
     */

  }, {
    key: "createCanvasElement",
    value: function createCanvasElement() {
      var canvas = document.createElement("canvas");
      return canvas;
    }
    /**
     * Internal helper to create a new HTMLDiv element.
     */

  }, {
    key: "createDivElement",
    value: function createDivElement() {
      var div = document.createElement("div");
      return div;
    }
  }, {
    key: "enchanceCanvasContext",
    value: function enchanceCanvasContext(ctx) {
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var xform = svg.createSVGMatrix();

      ctx.getTransform = function () {
        return xform;
      };

      var savedTransforms = [];
      var save = ctx.save;

      ctx.save = function () {
        savedTransforms.push(xform.translate(0, 0));
        return save.call(ctx);
      };

      var restore = ctx.restore;

      ctx.restore = function () {
        xform = savedTransforms.pop();
        return restore.call(ctx);
      };

      var scale = ctx.scale;

      ctx.scale = function (sx, sy) {
        xform = xform.scaleNonUniform(sx, sy);
        return scale.call(ctx, sx, sy);
      };

      var rotate = ctx.rotate;

      ctx.rotate = function (radians) {
        xform = xform.rotate(radians * 180 / Math.PI);
        return rotate.call(ctx, radians);
      };

      var translate = ctx.translate;

      ctx.translate = function (dx, dy) {
        xform = xform.translate(dx, dy);
        return translate.call(ctx, dx, dy);
      };

      var transform = ctx.transform;

      ctx.transform = function (a, b, c, d, e, f) {
        var m2 = svg.createSVGMatrix();
        m2.a = a;
        m2.b = b;
        m2.c = c;
        m2.d = d;
        m2.e = e;
        m2.f = f;
        xform = xform.multiply(m2);
        return transform.call(ctx, a, b, c, d, e, f);
      };

      var setTransform = ctx.setTransform;

      ctx.setTransform = function (a, b, c, d, e, f) {
        xform.a = a;
        xform.b = b;
        xform.c = c;
        xform.d = d;
        xform.e = e;
        xform.f = f;
        return setTransform.call(ctx, a, b, c, d, e, f);
      };

      var pt = svg.createSVGPoint();

      ctx.transformedPoint = function (x, y) {
        pt.x = x;
        pt.y = y;
        return pt.matrixTransform(xform.inverse());
      }; // wir vergrößern immer gleichmäßig daher brauchen nur einen Scale-Wert, entweder X oder Y


      ctx.currentScale = function () {
        return xform.a;
      };

      ctx.dx = function () {
        return xform.e;
      };

      ctx.dy = function () {
        return xform.f;
      };
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(evt) {
      this.lastX = evt.offsetX || evt.pageX - this.canvas.offsetLeft;
      this.lastY = evt.offsetY || evt.pageY - this.canvas.offsetTop;
      this.dragStart = this.canvasContext.transformedPoint(this.lastX, this.lastY);
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(evt) {
      this.lastX = evt.offsetX || evt.pageX - this.canvas.offsetLeft;
      this.lastY = evt.offsetY || evt.pageY - this.canvas.offsetTop;
      var allowDrag = this.dragStart && this.areaSelector.getSelectorSettings() && this.areaSelector.getSelectorSettings().mode === ISelectorSettings_1.SelectionMode.DRAG && this.canvasContext.currentScale() > 1.0;

      if (allowDrag) {
        var pt = this.canvasContext.transformedPoint(this.lastX, this.lastY);
        var dx = pt.x - this.dragStart.x;
        var dy = pt.y - this.dragStart.y; // lock left

        if (this.canvasContext.dx() + dx > 0.0) {
          dx = 0;
        } // lock top


        if (this.canvasContext.dy() + dy > 0.0) {
          dy = 0;
        } // lock right


        var maxDX = -this.canvas.width * (this.canvasContext.currentScale() - 1);

        if (this.canvasContext.dx() + dx < maxDX) {
          dx = 0;
        } // lock bottom


        var maxDY = -this.canvas.height * (this.canvasContext.currentScale() - 1);

        if (this.canvasContext.dy() + dy < maxDY) {
          dy = 0;
        }

        this.canvasContext.translate(dx, dy);
        this.regionsManager.transform(this.canvasContext.currentScale(), this.canvasContext.dx(), this.canvasContext.dy());
        this.draw();
      }
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(evt) {
      this.dragStart = null;
    }
  }, {
    key: "api",
    get: function get() {
      return this.mergedAPI;
    }
  }, {
    key: "RM",
    get: function get() {
      return this.regionsManager;
    }
    /**
     * Short reference to the `AreaSelector` component.
     */

  }, {
    key: "AS",
    get: function get() {
      return this.areaSelector;
    }
    /**
     * Short reference to the `FilterPipeline` component.
     */

  }, {
    key: "FP",
    get: function get() {
      return this.filterPipeline;
    }
  }]);

  return Editor;
}();

exports.Editor = Editor;
/**
 * The toolbar icons preset with all available features.
 */

Editor.FullToolbarSet = [{
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "none-select",
  iconFile: "none-selection.svg",
  tooltip: "Regions Manipulation (M)",
  keycode: "KeyM",
  actionCallback: function actionCallback(action, rm, sl) {
    sl.setSelectionMode({
      mode: ISelectorSettings_1.SelectionMode.NONE
    });
  },
  activate: true
}, {
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "none-select",
  iconFile: "drag.svg",
  tooltip: "Move image",
  keycode: "KeyD",
  actionCallback: function actionCallback(action, rm, sl) {
    sl.setSelectionMode({
      mode: ISelectorSettings_1.SelectionMode.DRAG
    });
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SEPARATOR
}, {
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "point-select",
  iconFile: "point-selection.svg",
  tooltip: "Point-selection (P)",
  keycode: "KeyP",
  actionCallback: function actionCallback(action, rm, sl) {
    sl.setSelectionMode({
      mode: ISelectorSettings_1.SelectionMode.POINT
    });
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "rect-select",
  iconFile: "rect-selection.svg",
  tooltip: "Rectangular box (R)",
  keycode: "KeyR",
  actionCallback: function actionCallback(action, rm, sl) {
    sl.setSelectionMode({
      mode: ISelectorSettings_1.SelectionMode.RECT
    });
  },
  activate: true
}, {
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "copy-select",
  iconFile: "copy-t-selection.svg",
  tooltip: "Template-based box (T)",
  keycode: "KeyT",
  actionCallback: function actionCallback(action, rm, sl) {
    var regions = rm.getSelectedRegions();

    if (regions !== undefined && regions.length > 0) {
      var r = regions[0];
      sl.setSelectionMode({
        mode: ISelectorSettings_1.SelectionMode.COPYRECT,
        template: new Rect_1.Rect(r.regionData.width, r.regionData.height)
      });
    } else {
      sl.setSelectionMode({
        mode: ISelectorSettings_1.SelectionMode.COPYRECT,
        template: new Rect_1.Rect(40, 40)
      });
    }
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "polyline-select",
  iconFile: "polyline-selection.svg",
  tooltip: "Polyline-selection (Y)",
  keycode: "KeyY",
  actionCallback: function actionCallback(action, rm, sl) {
    sl.setSelectionMode({
      mode: ISelectorSettings_1.SelectionMode.POLYLINE
    });
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "polygon-select",
  iconFile: "polygon-selection.svg",
  tooltip: "Polygon-selection (O)",
  keycode: "KeyO",
  actionCallback: function actionCallback(action, rm, sl) {
    sl.setSelectionMode({
      mode: ISelectorSettings_1.SelectionMode.POLYGON
    });
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SEPARATOR
}, {
  type: ToolbarIcon_1.ToolbarItemType.TRIGGER,
  action: "delete-all-select",
  iconFile: "delete-all-selection.svg",
  tooltip: "Delete all regions",
  keycode: "",
  actionCallback: function actionCallback(action, rm, sl) {
    rm.deleteAllRegions();
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SEPARATOR
}, {
  type: ToolbarIcon_1.ToolbarItemType.SWITCH,
  action: "selection-lock",
  iconFile: "selection-lock.svg",
  tooltip: "Lock/unlock regions (L)",
  keycode: "KeyL",
  actionCallback: function actionCallback(action, rm, sl) {
    rm.toggleFreezeMode();
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SWITCH,
  action: "background-toggle",
  iconFile: "background-toggle.svg",
  tooltip: "Toggle Region Background (B)",
  keycode: "KeyB",
  actionCallback: function actionCallback(action, rm, sl) {
    rm.toggleBackground();
  },
  activate: false
}];
/**
 * The toolbar icons preset with only rect-related features.
 */

Editor.RectToolbarSet = [{
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "none-select",
  iconFile: "none-selection.svg",
  tooltip: "Regions Manipulation (M)",
  keycode: "KeyM",
  actionCallback: function actionCallback(action, rm, sl) {
    sl.setSelectionMode({
      mode: ISelectorSettings_1.SelectionMode.NONE
    });
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SEPARATOR
}, {
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "rect-select",
  iconFile: "rect-selection.svg",
  tooltip: "Rectangular box (R)",
  keycode: "KeyR",
  actionCallback: function actionCallback(action, rm, sl) {
    sl.setSelectionMode({
      mode: ISelectorSettings_1.SelectionMode.RECT
    });
  },
  activate: true
}, {
  type: ToolbarIcon_1.ToolbarItemType.SELECTOR,
  action: "copy-select",
  iconFile: "copy-t-selection.svg",
  tooltip: "Template-based box (T)",
  keycode: "KeyT",
  actionCallback: function actionCallback(action, rm, sl) {
    var regions = rm.getSelectedRegions();

    if (regions !== undefined && regions.length > 0) {
      var r = regions[0];
      sl.setSelectionMode({
        mode: ISelectorSettings_1.SelectionMode.COPYRECT,
        template: new Rect_1.Rect(r.regionData.width, r.regionData.height)
      });
    } else {
      sl.setSelectionMode({
        mode: ISelectorSettings_1.SelectionMode.COPYRECT,
        template: new Rect_1.Rect(40, 40)
      });
    }
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SEPARATOR
}, {
  type: ToolbarIcon_1.ToolbarItemType.TRIGGER,
  action: "delete-all-select",
  iconFile: "delete-all-selection.svg",
  tooltip: "Delete all regions",
  keycode: "",
  actionCallback: function actionCallback(action, rm, sl) {
    rm.deleteAllRegions();
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SEPARATOR
}, {
  type: ToolbarIcon_1.ToolbarItemType.SWITCH,
  action: "selection-lock",
  iconFile: "selection-lock.svg",
  tooltip: "Lock/unlock regions (L)",
  keycode: "KeyL",
  actionCallback: function actionCallback(action, rm, sl) {
    rm.toggleFreezeMode();
  },
  activate: false
}, {
  type: ToolbarIcon_1.ToolbarItemType.SWITCH,
  action: "background-toggle",
  iconFile: "background-toggle.svg",
  tooltip: "Toggle Region Background (B)",
  keycode: "KeyB",
  actionCallback: function actionCallback(action, rm, sl) {
    rm.toggleBackground();
  },
  activate: false
}];
/**
 * Internal SVG template to define shadow filter.
 */

Editor.SVGDefsTemplate = "\n        <defs>\n            <filter id=\"black-glow\">\n                <feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"2\" />\n                <feOffset dx=\"0\" dy=\"0\" result=\"offsetblur\" />\n                <feComponentTransfer>\n                    <feFuncA type=\"linear\" slope=\"0.8\" />\n                </feComponentTransfer>\n                <feMerge>\n                    <feMergeNode />\n                    <feMergeNode in=\"SourceGraphic\" />\n                </feMerge>\n            </filter>\n        </defs>";